export default __webpack_public_path__ + "static/media/Travel-Lamu-Cover Preview.1fe66ed2.png";